import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink';
import { getNewFormsEditorBetaOptInRoute } from 'FormsUI/lib/RouteGenerators';
import { jsx as _jsx } from "react/jsx-runtime";
const FormsNewEditorBreezeOptIn = () => /*#__PURE__*/_jsx(UIAlert, {
  type: "warning",
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "editor.enrichmentOptInAlert.title"
  }),
  children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "editor.enrichmentOptInAlert.description_jsx",
    elements: {
      UILink
    },
    options: {
      href: getNewFormsEditorBetaOptInRoute(),
      external: true
    }
  })
});
export default FormsNewEditorBreezeOptIn;